<div id="device-table">
  <ep-device-table
    [devices]="devices$ | async"
    [statusSeverity]="statusSeverity"
    (addNew)="addNew()"
    (rowClick)="rowClick($event)"
  ></ep-device-table>
</div>
